// import Button from '@/components/Button';
import useSearch from '@/components/search/useSearch';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import SupplierTable from '@/modules/store/components/SupplierTable';
// import { SettingsSupplierAddPath } from '@/modules/store/paths';
import { TruckIcon } from '@heroicons/react/24/outline';
// import { PlusIcon } from '@heroicons/react/24/solid';

const SupplierList = () => {
  const { page, handlePageChange } = useSearch();

  const { currentUser } = useAuth();

  const { storeId } = currentUser();

  // const addSupplierButton = (
  //   <Button
  //     to={SettingsSupplierAddPath}
  //     icon={<PlusIcon className="h-5 w-5 mr-1" />}
  //     variant="secondary"
  //   >
  //     Add Supplier
  //   </Button>
  // );

  return (
    <>
      <SettingsHeader title="Suppliers" icon={<TruckIcon className="w-6 h-6" />} />

      <SupplierTable page={page} onChangePage={handlePageChange} currentStoreId={storeId} />
    </>
  );
};

export default SupplierList;
